
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import {listGender, listMarriage} from "../../../../../../../data/list";
const { INPUT, DATE, SELECT, TEXT_AREA, TIME, NUMBER, COMBO_BOX, AUTO_COMPLETE } = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
const mapOptions: DataFormField[] = [

    {
        name: "soTaiKhoanNganHang",
        type: INPUT,
        label: "Số tài khoản",
        disable: true,
        css:css,
        wrapperCol: { xs: 24,sm:14, md: 16, lg: 18, xl: 18 },
        labelCol: { xs: 24,sm:10, md: 8, lg: 6, xl: 6},
        rules: [{
            pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
            message: "Chỉ cho phép nhập số"
        }],
    },
    {
        name: "nganHang",
        type: AUTO_COMPLETE ,
        label: "Ngân Hàng",
        disable: true,
        css:css,
        wrapperCol: { xs: 24,sm:14, md: 16, lg: 18, xl: 18 },
        labelCol: { xs: 24,sm:10, md: 8, lg: 6, xl: 6},
    },
    {
        name: "cccdCapMST",
        type: INPUT,
        label: "CCCD cấp MST",
        disable: true,
        css:css,
        wrapperCol: { xs: 24,sm:14, md: 16, lg: 18, xl: 18 },
        labelCol: { xs: 24,sm:10, md: 8, lg: 6, xl: 6},
        rules: [{
            pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
            message: "Chỉ cho phép nhập số"
        }],
    },
    {
        name: "ngayCapSoTaiKhoanNganHang",
        type: DATE,
        label: "Ngày cấp",
        disable: true,
        css:css,
        wrapperCol: { xs: 24,sm:14, md: 16, lg: 18, xl: 18 },
        labelCol: { xs: 24,sm:10, md: 8, lg: 6, xl: 6},
    },
    {
        type: INPUT,
        label: "Nơi cấp",
        css:css,
        wrapperCol: { xs: 24,sm:14, md: 16, lg: 18, xl: 18 },
        labelCol: { xs: 24,sm:10, md: 8, lg: 6, xl: 6},
        name: "noiCapSoTaiKhoanNganHang",
        disable: true,
    },
    {
        name: "maSoThueTNCN",
        type: INPUT,
        label: "Mã số thuế TNCN",
        disable: true,
        css:css,
        wrapperCol: { xs: 24,sm:14, md: 16, lg: 18, xl: 18 },
        labelCol: { xs: 24,sm:10, md: 8, lg: 6, xl: 6},
    },
    {
        name: "maSoBHXH",
        type: INPUT,
        label: "Mã số BHXH",
        disable: true,
        css:css,
        wrapperCol: { xs: 24,sm:14, md: 16, lg: 18, xl: 18 },
        labelCol: { xs: 24,sm:10, md: 8, lg: 6, xl: 6},
    },
    {
        name: "soBHYT",
        type: INPUT,
        label: "Số sổ BHYT",
        disable: true,
        css:css,
        wrapperCol: { xs: 24,sm:14, md: 16, lg: 18, xl: 18 },
        labelCol: { xs: 24,sm:10, md: 8, lg: 6, xl: 6},
        // rules: [
        //     {
        //         pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        //         message: "Chỉ cho phép nhập số"
        //     }],
    },

];

export {mapOptions};
